// extracted by mini-css-extract-plugin
export default {"numeric-badge":"numeric-badge__VlluS","label":"label__2FAL1"};